module.exports = __webpack_public_path__ + "media/icons/youtube-857afc48.svg";